
import React from "react";
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Navbar from './layout/Navbar';
import HomePage from './pages/HomePage';
import AllRoutes from './nametitle/AllRoutes';
import ContactPage from './pages/ContactPage';
import TemoignagePage from './pages/TemoignagePage';
import EvenementPage from './pages/EvenementPage';
import DonPage from './pages/DonPage';
import MemberSignUpPage from './pages/MemberSignUpPage';
import SchoolBiblePage from './pages/SchoolBiblePage';
import DetailActivity from "./pages/DetailActivity";
import NavbarAdmin from "./layout/admin/NavbarAdmin";
import DasboardAdmin from "./pages/admin/DasboardAdmin";
import LayoutTemoignageAdmin from "./layout/admin/temoignage/LayoutTemoignageAdmin";
import ListTemoignageAdminPage from "./pages/admin/temoignage/ListTemoignageAdminPage";
import AddTemoignagePage from "./pages/admin/temoignage/AddTemoignagePage";
import UpdateTemoignagePage from "./pages/admin/temoignage/UpdateTemoignagePage";
import ViewTemoignagePage from "./pages/admin/temoignage/ViewTemoignagePage";
import ListMemberPage from "./pages/admin/members/ListMemberPage";
import ListUserPage from "./pages/admin/users/ListUserPage";
import LayoutActvityAdmin from "./layout/admin/activites/LayoutActvityAdmin";
import ListActivityAdmin from "./pages/admin/activites/ListActivityAdmin";
import AboutUsPage from "./pages/AboutUsPage";
import ActiviteContentList from "./pages/admin/activitespage/ActiviteContentList";
import LoginAdmin from "./pages/LoginAdmin";
import VideoPage from "./pages/VideoPage";
import ListMessagePage from "./pages/admin/messages/ListMessagePage";
import ListEmailPage from "./pages/admin/emails/ListEmailPage";
import ListCommentPage from "./pages/admin/comments/ListCommentPage";
import BibleBooksPage from "./pages/BibleBooksPage";
import { LanguageProvider } from "./app/LanguageContext";
import ListFidelesPage from "./pages/admin/fideles/ListFidelesPage";
import DonationCheckoutPage from "./pages/DonationCheckoutPage";

function App() {
  return (
    <div className="">
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          {/* Conexion ***********************************************************************************/}
          <Route path={`/${AllRoutes.login}`} element={<LoginAdmin />} />
          {/* Admin ***********************************************************************************/}
          <Route path={`${AllRoutes.admin}`} element={<NavbarAdmin />} >
            <Route index element={<DasboardAdmin />} />
            {/* Temoignage Admin */}
            <Route path={`${AllRoutes.temoins}`} element={<LayoutTemoignageAdmin />}>
              <Route index element={<ListTemoignageAdminPage />} />
              <Route path={`${AllRoutes.temoins_details}`} element={<ViewTemoignagePage />} />
              <Route path={`${AllRoutes.add}`} element={<AddTemoignagePage />} />
              <Route path={`${AllRoutes.update}/:id`} element={<UpdateTemoignagePage />} />
            </Route>
            {/* Membres */}
            <Route path={`${AllRoutes.memberlist}`} element={<ListMemberPage />} />
            {/* Messages */}
            <Route path={`${AllRoutes.message}`} element={<ListMessagePage />} />
            {/*Fideles */}
            <Route path={`${AllRoutes.fildelsList}`} element={<ListFidelesPage />} />
            {/*commentaires */}
            <Route path={`${AllRoutes.commentList}`} element={<ListCommentPage/>}/>
            {/* email */}
            <Route path={`${AllRoutes.emaillist}`} element={<ListEmailPage />} />
            {/* Utlisateurs */}
            <Route path={`${AllRoutes.userlist}`} element={<ListUserPage />} />
            {/* Activités */}
            <Route path={`${AllRoutes.activity}`} element={<LayoutActvityAdmin />}>
              <Route index element={<ListActivityAdmin />} />
            </Route>
            <Route path={`${AllRoutes.contentPage}`} element={<ActiviteContentList />} />
          </Route>



          
          {/* Site web ********************************************************************************/}
          <Route path="/" element={<Navbar />}>
            <Route index element={<HomePage />} />
            <Route index path={`${AllRoutes.about}`} element={<AboutUsPage />} />
            <Route index path={`${AllRoutes.contact}`} element={<ContactPage />} />
            {/*Livres de la bible */}
            <Route index path={`${AllRoutes.bible}`} element={<BibleBooksPage />} />
            {/* temoignage */}
            <Route index path={`${AllRoutes.temoignage}`} element={<TemoignagePage />} />
            <Route index path={`${AllRoutes.temoignage}/:id`} element={<DetailActivity />} />
            {/*ckeouton donation */}
            <Route index path={`${AllRoutes.donationckeckout}`} element={<DonationCheckoutPage />} />
            {/* Evenement */}
            <Route index path={`${AllRoutes.evenement}`} element={<EvenementPage />} />
            <Route index path={`${AllRoutes.evenement}/:id`} element={<DetailActivity />} />
            {/* Dons */}
            <Route index path={`${AllRoutes.dons}`} element={<DonPage />} />
            <Route index path={`${AllRoutes.dons}/:id`} element={<DetailActivity />} />
            <Route index path={`${AllRoutes.ecole}`} element={<SchoolBiblePage />} />
            <Route index path={`${AllRoutes.ecole}/:id`} element={<VideoPage />} />
            <Route index path={`${AllRoutes.member}`} element={<MemberSignUpPage />} />
          </Route>
          {/* BackOffice */}
        </Routes>
      </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
